import { c as _c } from "react/compiler-runtime";
import type { CSSProperties } from "react";
import { RankChangeType } from "@/widgets/search-ranking/model/types";
interface RankChangeProps {
  type: RankChangeType;
  value?: number;
}
const bebasStyle = {
  fontFamily: "var(--font-bebas-neue), sans-serif"
} as CSSProperties;
const rankChangeTextStyle = {
  ...bebasStyle,
  "--fs": 14,
  "--lh": 14
} as CSSProperties;
const rankChangeArrowStyle = {
  ...bebasStyle,
  "--fs": 10,
  "--lh": 10
} as CSSProperties;
const RankChange = t0 => {
  const $ = _c(8);
  const {
    type,
    value
  } = t0;
  if (type === "new") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <span className="fs font-normal uppercase tracking-[0.21px] text-[#E85A5D]" style={rankChangeTextStyle}>new</span>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (type === "same") {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <span className="fs font-bold text-gray-200" style={rankChangeTextStyle}>-</span>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (type === "down") {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <span className="fs leading-none" style={rankChangeArrowStyle}>▼</span>;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] !== value) {
      t2 = <span className="inline-flex items-center gap-0.5 text-[#7FCCF0]" style={bebasStyle}>{t1}<span className="fs" style={rankChangeTextStyle}>{value}</span></span>;
      $[3] = value;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="fs leading-none" style={rankChangeArrowStyle}>▲</span>;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== value) {
    t2 = <span className="inline-flex items-center gap-0.5 text-[#E85A5D]" style={bebasStyle}>{t1}<span className="fs" style={rankChangeTextStyle}>{value}</span></span>;
    $[6] = value;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default RankChange;